import React from "react";
import PropTypes from "prop-types";
interface ScreenshotInputProps {
  name: string;
  allowedMimeTypes: string[];
  readOnly?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: string;
}
const ScreenshotInput = ({
  name,
  allowedMimeTypes,
  readOnly,
  onChange,
  error
}: ScreenshotInputProps) => <div className="form__group" data-sentry-component="ScreenshotInput" data-sentry-source-file="ScreenshotInput.tsx">
    <div className="form__control-container">
      {readOnly ? <>
          <input type="text" className="form__control" value={name} readOnly />
          <label className="form__label">Screenshot</label>
        </> : <>
          <label>Upload Screenshot</label>
          <input type="file" className="input-file" id="priceGaurantee_screenshot" name="priceGaurantee_screenshot" size={64} accept={allowedMimeTypes.join(",")} onChange={onChange} data-testid="price-guarantee-input-file" />
          <label className="form__control form__control--file" htmlFor="priceGaurantee_screenshot">
            <b className="file__button">Choose file</b>
            <span className="file__text">{name}</span>
          </label>
        </>}
    </div>
    {error && <div className="form__error">{error}</div>}
  </div>;
ScreenshotInput.propTypes = {
  name: PropTypes.string.isRequired,
  allowedMimeTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};
ScreenshotInput.defaultProps = {
  readOnly: false
};
export default ScreenshotInput;